import { render, staticRenderFns } from "./newSubSectionPopulation.vue?vue&type=template&id=7088cfd5&scoped=true"
import script from "./newSubSectionPopulation.vue?vue&type=script&lang=js"
export * from "./newSubSectionPopulation.vue?vue&type=script&lang=js"
import style0 from "./newSubSectionPopulation.vue?vue&type=style&index=0&id=7088cfd5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7088cfd5",
  null
  
)

export default component.exports